import * as React from 'react';
import { Placeholder } from 'vendors/semantic-ui';

import styles from './bloc-actualite-component.module.css';

export const BlocActualiteLoader: React.FC = React.memo(() => {
    return (
        <div>
            <div className={styles.titleBlock}>
                <Placeholder className={styles.title}>
                    <Placeholder.Image style={{ width: '250px', height: '36px' }} />
                </Placeholder>
                <ul className={styles.tags}>
                    {Array.from(Array(4).keys()).map(key => {
                        return (
                            <li key={key} className={styles.tag}>
                                <Placeholder>
                                    <Placeholder.Image style={{ width: '150px', height: '28px' }} />
                                </Placeholder>
                            </li>
                        );
                    })}
                </ul>
                <Placeholder className={`${styles.subtitle} full-width`}>
                    <Placeholder.Image style={{ width: '100%', height: '70px' }} />
                </Placeholder>
            </div>
            <div className={styles.news}>
                {Array.from(Array(8).keys()).map(key => {
                    return (
                        <div key={key} className={styles.newsItem}>
                            <Placeholder fluid>
                                <Placeholder.Image style={{ height: '550px' }} />
                            </Placeholder>
                        </div>
                    );
                })}
            </div>
        </div>
    );
});
